var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, Grid, Header, Input, Loader, Menu, Message, Modal, Select, Table } from "semantic-ui-react";
import { getWithAuthn } from "../RequestHelpers";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
import ReactTable from "react-table";
import { displayLocalTimestamp } from "./AllOrdersPage";
var ManualBufferTrackingPage = /** @class */ (function (_super) {
    __extends(ManualBufferTrackingPage, _super);
    function ManualBufferTrackingPage(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null),
                        React.createElement(Table.HeaderCell, null, "10mL aliquots"),
                        React.createElement(Table.HeaderCell, null, "25mL aliquots"),
                        React.createElement(Table.HeaderCell, null, "50mL aliquots"),
                        React.createElement(Table.HeaderCell, null, "100mL aliquots"),
                        React.createElement(Table.HeaderCell, null, "200mL aliquots"))),
                React.createElement(Table.Body, null, resp.manualBuffers.map(function (entry, index) {
                    var _a;
                    return React.createElement(Table.Row, { key: index },
                        React.createElement(Table.Cell, null,
                            entry.buffer.label,
                            " ",
                            _this.state.response && _this.editManualBufferEntry(entry, (_a = _this.state.response) === null || _a === void 0 ? void 0 : _a.manualBuffersCatalog)),
                        React.createElement(Table.Cell, null, entry.aliquots10Ml),
                        React.createElement(Table.Cell, null, entry.aliquots25Ml),
                        React.createElement(Table.Cell, null, entry.aliquots50Ml),
                        React.createElement(Table.Cell, null, entry.aliquots100Ml),
                        React.createElement(Table.Cell, null, entry.aliquots200Ml));
                })));
        };
        _this.renderEventsTable = function (resp) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Events"),
                React.createElement(ReactTable, { columns: [
                        {
                            id: 'name',
                            Header: 'User',
                            accessor: function (e) { return e.user.name; }
                        },
                        {
                            id: 'type',
                            Header: 'Type',
                            accessor: function (e) { return e.type; }
                        },
                        {
                            id: 'buffer',
                            Header: 'Buffer',
                            accessor: function (e) { return e.manualBuffer.label; }
                        },
                        {
                            id: 'msg',
                            Header: 'Message',
                            accessor: function (e) { return e.msg; },
                            Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                        },
                        {
                            id: 'createdAt',
                            Header: 'Created',
                            accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                        },
                    ], data: resp.manualBufferEvents, defaultPageSize: 50, defaultSorted: [{
                            id: 'createdAt'
                        }], minRows: 1 }));
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/inventory/manual-buffers')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.inputNewAliquots = function (buffers) {
            var renderManualBufferModal = function (props) {
                return React.createElement(ManualBufferModal, __assign({ buffers: buffers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Input new aliquots' }) },
                React.createElement(Modal.Header, null, "Input new manual buffer"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderManualBufferModal, successMessage: 'New aliquots inputted' })));
        };
        _this.editManualBufferEntry = function (manualBufferEntry, buffers) {
            var renderManualBufferModal = function (props) {
                return React.createElement(ManualBufferModal, __assign({ manualBufferEntry: manualBufferEntry, buffers: buffers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'edit', size: 'tiny' }) },
                React.createElement(Modal.Header, null, "Edit manual buffer inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderManualBufferModal, successMessage: 'Inventory updated' })));
        };
        _this.uploadInventory = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload inventory' }) },
                React.createElement(Modal.Header, null, "Upload inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/admin/inventory/manual-buffers/upload-current-inventory" })));
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    ManualBufferTrackingPage.prototype.render = function () {
        var _a;
        return React.createElement(Dimmer.Dimmable, { className: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null, this.uploadInventory()),
                React.createElement(Menu.Item, null, this.state.response &&
                    this.inputNewAliquots((_a = this.state.response) === null || _a === void 0 ? void 0 : _a.manualBuffersCatalog))),
            this.state.response && this.renderTable(this.state.response),
            this.state.response && this.renderEventsTable(this.state.response));
    };
    ManualBufferTrackingPage.prototype.componentDidMount = function () {
        this.loadData();
    };
    return ManualBufferTrackingPage;
}(React.PureComponent));
export default ManualBufferTrackingPage;
;
var ManualBufferModal = /** @class */ (function (_super) {
    __extends(ManualBufferModal, _super);
    function ManualBufferModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onLotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ lotNumber: str });
        };
        _this.onBufferChange = function (_, data) {
            var valStr = data.value;
            var foundBuffer = _this.props.buffers.find(function (b) {
                return b.id === valStr;
            });
            if (foundBuffer === undefined) {
                throw new RangeError("Invalid buffer " + valStr);
            }
            _this.setState({
                manualBuffer: foundBuffer
            });
        };
        _this.onAliquots10MlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ aliquots10Ml: num });
        };
        _this.onAliquots25MlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ aliquots25Ml: num });
        };
        _this.onAliquots50MlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ aliquots50Ml: num });
        };
        _this.onAliquots100MlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ aliquots100Ml: num });
        };
        _this.onAliquots200MlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ aliquots200Ml: num });
        };
        _this.submit = function () {
            if (_this.props.manualBufferEntry == null) {
                _this.props.postRequest("/admin/inventory/manual-buffers/add-new-aliquots", {
                    lotNumber: _this.state.lotNumber,
                    bufferId: _this.state.manualBuffer.id,
                    aliquots10Ml: _this.state.aliquots10Ml,
                    aliquots25Ml: _this.state.aliquots25Ml,
                    aliquots50Ml: _this.state.aliquots50Ml,
                    aliquots100Ml: _this.state.aliquots100Ml,
                    aliquots200Ml: _this.state.aliquots200Ml
                });
            }
            else {
                _this.props.postRequest("/admin/inventory/manual-buffers/update-existing-entry/id/" + encodeURIComponent(_this.props.manualBufferEntry.id), {
                    aliquots10Ml: _this.props.manualBufferEntry.aliquots10Ml === _this.state.aliquots10Ml ? null : _this.state.aliquots10Ml,
                    aliquots25Ml: _this.props.manualBufferEntry.aliquots25Ml === _this.state.aliquots25Ml ? null : _this.state.aliquots25Ml,
                    aliquots50Ml: _this.props.manualBufferEntry.aliquots50Ml === _this.state.aliquots50Ml ? null : _this.state.aliquots50Ml,
                    aliquots100Ml: _this.props.manualBufferEntry.aliquots100Ml === _this.state.aliquots100Ml ? null : _this.state.aliquots100Ml,
                    aliquots200Ml: _this.props.manualBufferEntry.aliquots200Ml === _this.state.aliquots200Ml ? null : _this.state.aliquots200Ml
                });
            }
        };
        _this.state = {
            lotNumber: "",
            manualBuffer: props.manualBufferEntry ? props.manualBufferEntry.buffer : _this.props.buffers[0],
            aliquots10Ml: props.manualBufferEntry ? props.manualBufferEntry.aliquots10Ml : 0,
            aliquots25Ml: props.manualBufferEntry ? props.manualBufferEntry.aliquots25Ml : 0,
            aliquots50Ml: props.manualBufferEntry ? props.manualBufferEntry.aliquots50Ml : 0,
            aliquots100Ml: props.manualBufferEntry ? props.manualBufferEntry.aliquots100Ml : 0,
            aliquots200Ml: props.manualBufferEntry ? props.manualBufferEntry.aliquots200Ml : 0
        };
        return _this;
    }
    ManualBufferModal.prototype.render = function () {
        return React.createElement(Grid, { columns: 3 },
            this.props.manualBufferEntry == null &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/lotNumber', labelContent: 'Lot Number' },
                            React.createElement(Input, { onChange: this.onLotNumberChange, placeholder: 'Lot Number', type: "text", value: this.state.lotNumber })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/buffer', errors: this.props.state.errors, labelContent: 'Buffer' },
                        React.createElement(Select, { className: "label-dropdown", disabled: this.props.manualBufferEntry != null, value: this.state.manualBuffer.id, onChange: this.onBufferChange, options: this.props.buffers.map(function (b) {
                                return {
                                    text: b.label,
                                    value: b.id
                                };
                            }) })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/aliquots10Ml', labelContent: '10mL aliquots' },
                        React.createElement(Input, { onChange: this.onAliquots10MlChange, placeholder: '0', type: "number", value: this.state.aliquots10Ml }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/aliquots25Ml', labelContent: '25mL aliquots' },
                        React.createElement(Input, { onChange: this.onAliquots25MlChange, placeholder: '0', type: "number", value: this.state.aliquots25Ml }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/aliquots50Ml', labelContent: '50mL aliquots' },
                        React.createElement(Input, { onChange: this.onAliquots50MlChange, placeholder: '0', type: "number", value: this.state.aliquots50Ml }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/aliquots100Ml', labelContent: '100mL aliquots' },
                        React.createElement(Input, { onChange: this.onAliquots100MlChange, placeholder: '0', type: "number", value: this.state.aliquots100Ml }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/aliquots200Ml', labelContent: '200mL aliquots' },
                        React.createElement(Input, { onChange: this.onAliquots200MlChange, placeholder: '0', type: "number", value: this.state.aliquots200Ml })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: this.props.manualBufferEntry ? 'Save update' : 'Add new manual buffer aliquots', labelPosition: 'left', onClick: this.submit, positive: true }))));
    };
    return ManualBufferModal;
}(React.PureComponent));
//# sourceMappingURL=ManualBufferTrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ManualBufferTrackingPage.js
// module id = 1473
// module chunks = 0